import httpClient from "./httpClient";

const base = "/class-routines";

export function listClassRoutines() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function uploadClassRoutine(classConfigId, file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(base, formData, { params: { classConfigId }, headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}

export function deleteClassRoutine(routineId) {
  return httpClient.delete(`${base}/${routineId}`).then((res) => res.data);
}
